import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { QuestionCardV4 } from "../../../components/common/QuestionCardV4";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	questions: 4,
	win: 5,
	fail: 6,
}
const gameQuestion = [
	{
		id: 1,
		question: 'Da clic encima de la opción " Financieros" en la pantalla.',
		options: [
			{
				id: 1,
				text: "Es el primer paso para realizar un retiro de efectivo.",
				isCorrect: true
			},
			{
				id: 2,
				text: "Presiona la Tecla T",
			},
			{
				id: 3,
				text: "Verifica que haya suficiente efectivo en la caja.",
			},
			{
				id: 4,
				text: "Pregunta al Cliente si los datos son correctos.",
			},
		]
	},
	{
		id: 2,
		question: 'El Cliente lleva productos consigo.',
		options: [
			{
				id: 1,
				text: "Es el primer paso para realizar un retiro de efectivo.",
			},
			{
				id: 2,
				text: "Presiona la Tecla T",
				isCorrect: true
			},
			{
				id: 3,
				text: "Verifica que haya suficiente efectivo en la caja.",
			},
			{
				id: 4,
				text: "Pregunta al Cliente si los datos son correctos.",
			},
		]
	},
	{
		id: 3,
		question: 'Antes de indicar que se puede realizar el retiro.',
		options: [
			{
				id: 1,
				text: "Es el primer paso para realizar un retiro de efectivo.",
			},
			{
				id: 2,
				text: "Presiona la Tecla T",
			},
			{
				id: 3,
				text: "Verifica que haya suficiente efectivo en la caja.",
				isCorrect: true
			},
			{
				id: 4,
				text: "Pregunta al Cliente si los datos son correctos.",
			},
		]
	},
	{
		id: 4,
		question: 'Antes de confirmar la transacción.',
		options: [
			{
				id: 1,
				text: "Es el primer paso para realizar un retiro de efectivo.",
			},
			{
				id: 2,
				text: "Presiona la Tecla T",
			},
			{
				id: 3,
				text: "Verifica que haya suficiente efectivo en la caja.",
			},
			{
				id: 4,
				text: "Pregunta al Cliente si los datos son correctos.",
				isCorrect: true
			},
		]
	},
]
let pointsAcumulated = 0

export const Tema5SubtopicThreeActivityThree = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema3], 3);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema3 activity 3");
			ObserverEmitter.emit(EVENTS.tema5.subtopicThree.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act3_a01)
	})

	const [selectQuestionGame, setSelectQuestionGame] = useState({
		question: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: ""
			},
			{
				id: 3,
				text: ""
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(0)

	const actionGameQuestion = (statusCorrect = 0) => {
		const updatedResponse = statusCorrect === 1 ? saveResponse + 1 : saveResponse;
		setSaveResponse(updatedResponse);

		// console.log(updatedResponse);
		pointsAcumulated = updatedResponse * 10

		if (numberQuestion >= gameQuestion.length - 1) {
			if (updatedResponse >= 2) {
				ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
				setUiToShow(steps.win);
			} else {
				ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
				setUiToShow(steps.fail);
			}
			return;
		}
		setNumberQuestion(numberQuestion + 1);
	};

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 4].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicThree.initScene, 3);
						setNumberQuestion(0)
						setSaveResponse(0)
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Ejercicio: Selecciona la opción correcta." />
					<DialogBarNew
						dialog={
							'¡Tu puedes lograrlo! Es hora de aplicar lo aprendido sobre remesas.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Remesas"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act3_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							'Selecciona la opción correcta para completar las oraciones referente a remesas.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.questions);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.questions && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<QuestionCardV4 data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsAcumulated}
						dialogModal="Has completado con éxito la sección sobre el Servicio de Corresponsalías."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema5.activities.subtema3,
								})
							);
							navigation("/home5/tema5/subtema3/results");
						}}
					/>
				</>
			)}
			{uiToShow === steps.fail && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={pointsAcumulated}
						dialogModal="¡No pierdas el ánimo! Verifica nuevamente los pasos a seguir para las corresponsalías."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema5.activities.subtema3,
								})
							);
							navigation("/home5/tema5/subtema3/results");
						}}
					/>
				</>
			)}

		</>

	)
}